import { ChangeEvent, DataSourceMode, Snackbar, ValidationResult } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { AutogenLayoutSMC3Profile } from "./autogen/AutogenLayoutSMC3Profile";

export class SMC3Profile extends AutogenLayoutSMC3Profile {

    override onLoad(): void {
        this.addValidationQuoteTimeOut();
        this.addValidationBatchSize()
    }

    private addValidationQuoteTimeOut() {

        this.textboxQuoteTimeout.addlValidationCallback = (mode: DataSourceMode): ValidationResult => {

            if (mode === DataSourceMode.SEARCH) {
                return null;
            }

            const input = this.textboxQuoteTimeout.text;
            if (StringUtil.isEmptyString(input)) {
                Snackbar.showWarningSnackbar("Quote timeout was empty. Quote timeout must be between 1 and 30 seconds");
                this.activeRow.set({quote_timeout: null});
                return {
                    component: this.textboxQuoteTimeout, isValid: false,
                    validationMessage: "Quote timeout must be between 1 and 30 seconds"
                };
            }

            const timeoutValue = parseInt(input);
            if (isNaN(timeoutValue) || timeoutValue < 1 || timeoutValue > 30) {
                Snackbar.showWarningSnackbar("Quote timeout must be between 1 and 30 seconds");
                this.activeRow.set({quote_timeout: null});
                return {
                    component: this.textboxQuoteTimeout, isValid: false,
                    validationMessage: "Quote timeout must be between 1 and 30 seconds"
                };
            }

            this.textboxQuoteTimeout.tooltip = "Willing to wait for SMC3 rating calls. Valid range: 1-30 seconds"
            return null;
        }
    }

    private addValidationBatchSize() {

        this.textboxScacsBatchSize.addlValidationCallback = (mode: DataSourceMode): ValidationResult | null => {

            if (mode === DataSourceMode.SEARCH) {
                return null;
            }

            const input = this.textboxScacsBatchSize.text;
            if (StringUtil.isEmptyString(input)) {
                Snackbar.showWarningSnackbar("SCAC Batch Size is required and must be between 1 and 35");
                this.activeRow.set({ scacs_batch_size: null });
                return {
                    component: this.textboxScacsBatchSize, isValid: false,
                    validationMessage: "SCAC Batch Size must be between 1 and 35"
                };
            }

            const scacBatchSize = parseInt(input);
            if (isNaN(scacBatchSize) || scacBatchSize < 1 || scacBatchSize > 35) {
                Snackbar.showWarningSnackbar("SCAC Batch Size must be a number between 1 and 35");
                this.activeRow.set({ scacs_batch_size: null });
                return {
                    component: this.textboxScacsBatchSize, isValid: false,
                    validationMessage: "SCAC Batch Size must be a number between 1 and 35"
                };
            }

            this.textboxScacsBatchSize.tooltip = "The number of SCACs to send in a single request to the SMC3 Aggregate Pricing API. Valid range: 1-35";
            return null;
        };
    }

    switchCarrierConfigurationOnChange(event: ChangeEvent) {
        if (this.switchCarrierConfiguration.checked) {
            this.panelYesConfig.visible = true
            this.panelNoConfig.visible = false
        }
        else {
            this.panelYesConfig.visible = false
            this.panelNoConfig.visible = true
        }
    }

}
